export default {
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
}



// WEBPACK FOOTER //
// ./src/mixins/contextualable.js